import { Avatar } from "@mui/material";
import { colors } from "../../../ui/colors";

type AccountAvatarViewProps = {
  src?: string;
  initial: string;
  size?: number;
  alt?: string;
};

export const AccountAvatarView = ({ src, initial, size = 48, alt = "Account" }: AccountAvatarViewProps) => {
  return (
    <Avatar
      src={src}
      alt={alt}
      imgProps={{
        referrerPolicy: "no-referrer",
      }}
      sx={{
        width: size,
        height: size,
        bgcolor: colors.gray[300],
        color: "#fff",
        fontSize: size * 0.42,
        fontWeight: 800,
        boxShadow: "none",
        border: `1px solid ${colors.gray[100]}`,
      }}
    >
      {initial}
    </Avatar>
  );
};
